import { type IConfig, UnleashClient } from 'unleash-proxy-client'

const UNLEASH_REFRESH_INTERVAL = 60 // 1 minute

const unleashConfig: IConfig = {
  url: import.meta.env.VITE_UNLEASH_URL || '',
  clientKey: import.meta.env.VITE_UNLEASH_CLIENT_KEY || '',
  appName: import.meta.env.VITE_UNLEASH_APP_NAME || 'data-ingestion-optistream',
  refreshInterval: UNLEASH_REFRESH_INTERVAL,
  context: {
    properties: {
      deploymentStage: import.meta.env.VITE_DEPLOYMENT_STAGE || 'dev',
    },
  },
}

export const unleashClient = new UnleashClient(unleashConfig)
